<div class="page-wrapper">
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Canales y Tipo de Operaciones</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active"
            routerLink="/dashboard/inicio"
            style="cursor: pointer"
          >
            Inicio
          </li>
          <li class="breadcrumb-item" style="cursor: pointer">
            <a>Canales y Tipo de Operaciones</a>
          </li>
        </ol>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-md-12 col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <!-- MAT TABLE -->
              <div class="content-table">
                <table
                  mat-table
                  #dataTable
                  [dataSource]="dataSource"
                  matSort
                  style="width: 100%; --min-width: 600px"
                  class="table-striped text-center"
                >
                  <!-- NOMBRE -->
                  <ng-container matColumnDef="nombre">
                    <th
                      class="header-options"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    >
                      Canal/Producto
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.nombre }}
                    </td>
                  </ng-container>
                  <!-- ESTATUS -->
                  <!-- <ng-container matColumnDef="estatus">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Estatus
                  </th>
                  <td mat-cell *matCellDef="let element">
                    Activo
                  </td>
                </ng-container> -->
                  <!-- OPCIONES -->
                  <ng-container matColumnDef="opciones">
                    <th
                      class="header-options"
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                    ></th>
                    <td
                      class="text-center"
                      mat-cell
                      *matCellDef="let element"
                      class="options"
                    >
                      <!-- (click)="sessionStorage.setItem('id_canales',element.id_canales)" -->
                      <button
                        (click)="guardarIdCanal(element.id_canales)"
                        routerLink="tipos-de-operaciones"
                        class="btn-success btn btn-large mr-2"
                      >
                        <!-- <i class="mdi mdi-plus"></i> -->
                        tipos de operaciones
                      </button>
                      <button
                        *ngIf="actualizarTipos"
                        (click)="editar(element)"
                        class="btn btn-warning mr-2"
                      >
                        <i class="mdi mdi-pencil"></i>
                      </button>
                      <button
                        *ngIf="eliminarTipos"
                        (click)="eliminar(element.id_canales)"
                        class="btn btn-danger"
                      >
                        <i class="mdi mdi-delete"></i>
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="select-options">
                    <th
                      mat-header-cell
                      class="th-options"
                      colspan="2"
                      *matHeaderCellDef
                    >
                      <div class="search">
                        <i class="fas fa-search"></i>
                        <input
                          type="text"
                          [(ngModel)]="buscar"
                          (keyup)="search()"
                          matInput
                          placeholder="Filtrar..."
                        />
                      </div>
                      <div class="content-options" *ngIf="crearTipos">
                        <i
                          class="fas fa-plus"
                          matTooltip="Agregar Canal/Producto"
                          (click)="crear()"
                        ></i>
                      </div>
                    </th>
                  </ng-container>

                  <tr
                    mat-header-row
                    class="tr-options"
                    *matHeaderRowDef="['select-options']"
                  ></tr>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>

                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="2" style="text-align: center">
                      No se han encontrado registros de canales y operaciones!!
                    </td>
                  </tr>
                </table>
              </div>
              <mat-paginator
                [pageSizeOptions]="[5, 10, 25, 50, 100]"
                [pageSize]="5"
                [showFirstLastButtons]
              ></mat-paginator>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLabel1">Nuevo Canal</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form [formGroup]="channelCreateForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <label for="recipient-name" class="control-label"
                    >Nombre:</label
                  >
                  <input
                    formControlName="nombre"
                    type="text"
                    class="form-control"
                    id="recipient-name1"
                  />
                </div>
                <button type="submit" class="btn btn-primary">
                  Crear Canal
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End PAge Content -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
  </div>
</div>
